export function getFlag (){
    return window.localStorage.getItem('flag')
}
export function setFlag (flag){
    return window.localStorage.setItem('flag',flag)
}
